import type React from 'react';
import { FormField, Label, Textarea } from '@zillow/constellation-10';

import type { Section } from '../../../models/index';
import { BED_BUGS } from '../../../constants';
import YesAndNoExpansion from '../../Widgets/YesAndNoExpansion';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function BedBugs({ section, setSectionValues }: Props) {
  function onBedBugsYesClick(): void {
    setSectionValues({
      [BED_BUGS.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  function onBedBugsNoClick(): void {
    setSectionValues({
      [BED_BUGS.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onDescriptionChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [BED_BUGS.FIELD_NAME.DESCRIPTION]: value,
    });
  }

  const bedBugsEnabled = section.getFieldValue(BED_BUGS.FIELD_NAME.IS_ENABLED);

  return (
    <FormField
      required
      label={<Label>Within the last 120 days, has there been any history of bed bug infestation?</Label>}
      control={
        <YesAndNoExpansion yesHandler={onBedBugsYesClick} noHandler={onBedBugsNoClick} yesActive={bedBugsEnabled}>
          <FormField
            required
            label={<Label>Describe where and when</Label>}
            control={
              <Textarea
                onChange={onDescriptionChange}
                value={section.getFieldValue(BED_BUGS.FIELD_NAME.DESCRIPTION)}
                css={{ resize: 'vertical' }}
                disabled={section.isFieldDisabled(BED_BUGS.FIELD_NAME.DESCRIPTION)}
              />
            }
          />
        </YesAndNoExpansion>
      }
    />
  );
}
